import { Api } from 'utils';

export type ReportsSection = 'users' | 'patrimony' | 'plans' | 'chat' | 'activity';

interface ReportsParams {
	since?: string;
	until?: string;
	period?: 'today' | 'week' | 'month' | 'year' | 'all' | 'custom';
	withoutLoading?: boolean;
}

class ReportsService {

	static admin = {
		get: async (section: ReportsSection, params?: ReportsParams) =>
			Api.createResponse(`admin/reports/${ section }`, params),

		getSubusersDetail: async (params?: { parent_user_id?: number; withoutLoading?: boolean }) =>
			Api.createResponse('admin/reports/users/subusers-detail', params),
	}

}

export default ReportsService;
